import React, { useEffect, useState } from 'react';
import { Breakpoint } from 'types/utils';
import { avatarWrapper, DivAvatar, ImgAvatar } from './avatar-with-fallback.styles';
import { convertBackgroundColor, convertTextColor } from './utils';

export type AvatarColor = 'default' | 'green' | 'blue' | 'purple' | 'red' | 'orange' | 'turquoise';

export interface AvatarWithFallbackProps {
  breakpoint?: Breakpoint;
  name?: string;
  imageSrc?: string | null;
  color?: AvatarColor;
  role?: string;
  'data-qa'?: string;
}

export const AvatarWithFallback: React.FC<AvatarWithFallbackProps> = ({
  name,
  color,
  imageSrc,
  ...htmlProps
}) => {
  const [mounted, setMounted] = useState(false);
  const [usedColor, setUsedColor] = useState(color as string);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (usedColor !== color) setUsedColor(usedColor);
  }, [usedColor, color]);

  if (!mounted) {
    return null;
  }

  return (
    <div className={avatarWrapper}>
      <DivAvatar
        style={{
          backgroundColor: convertBackgroundColor(usedColor as AvatarColor | undefined),
          color: convertTextColor(usedColor as AvatarColor | undefined),
        }}
        data-placeholder={name}
        role="img"
        data-testid="avatar-picture"
        aria-label={name}
        {...htmlProps}
      >
        {imageSrc ? (
          <ImgAvatar
            src={imageSrc}
            alt=""
            loading="lazy"
            data-qa="review-avatar-img"
            data-placeholder={name}
          />
        ) : null}
      </DivAvatar>
    </div>
  );
};
